"use client";

import { useTranslation } from "next-i18next";
import Image from "next/image";
import Link from "next/link";
import { ArrowUpLeft, ArrowUpRight } from "lucide-react";
import { parseJsonBody } from "@/lib/general.utils";
import useGeneralStore from "@/store/General/useGeneralStore";

const ServicesComponent = () => {
  const { t, i18n } = useTranslation("common");
  const servicesData = useGeneralStore((state) => state.ServicesComponent);
  const services = parseJsonBody(servicesData?.jsonBody).services || [];
  const Arrow = i18n.dir() === "rtl" ? ArrowUpLeft : ArrowUpRight;
  return (
    <section
      dir={i18n.dir()}
      lang={i18n.language}
      className="bg-white py-[3rem] md:py-[5rem] px-[1rem] md:px-[2rem]"
    >
      <div className="max-w-[120rem] mx-auto">
        <h1 className="text-[2rem] sm:text-[2.5rem] md:text-[3rem] lg:text-[4rem] font-bold text-tertiary text-center mb-[3rem]">
          {servicesData?.title || t("services.title")}
        </h1>
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-[1.5rem] md:gap-[2rem]">
          {services.map((service: any) => (
            <article
              key={service.id || service.slug}
              className="bg-white rounded-[1rem] shadow-lg overflow-hidden h-full flex flex-col"
            >
              <Link
                href={`/services/${service.slug}`}
                aria-label={service.title}
                className="relative block aspect-[3/2] shrink-0"
              >
                {service.imgUrl && (
                  <Image
                    src={service.imgUrl}
                    alt={service.title}
                    fill
                    sizes="(max-width: 640px) 100vw, (max-width: 1280px) 50vw, 25vw"
                    className="object-cover"
                  />
                )}
              </Link>
              <div className="p-[1.5rem] md:p-[2rem] flex flex-col flex-1">
                <h2 className="text-[1.2rem] md:text-[1.5rem] font-bold text-tertiary leading-[1.6] mb-[1rem] min-h-[3.84rem] md:min-h-[4.8rem]">
                  <Link href={`/services/${service.slug}`}>
                    {service.title}
                  </Link>
                </h2>
                <p className="text-[1rem] text-[#575757] leading-[1.8] line-clamp-3 mb-[1.5rem]">
                  {service.description}
                </p>
                <Link
                  href={`/services/${service.slug}`}
                  className="inline-flex items-center justify-center gap-2 self-start bg-secondary text-white text-[1rem] font-bold rounded-[0.5rem] px-[1.5rem] py-[0.75rem] mt-auto"
                >
                  {t("blogsPage.readMore")}{" "}
                  <Arrow size={17} aria-hidden="true" />
                </Link>
              </div>
            </article>
          ))}
        </div>
        {!services.length && (
          <p className="text-center text-gray-500">
            {t("services.placeholder")}
          </p>
        )}
      </div>
    </section>
  );
};
export default ServicesComponent;
